import { EStorageKey } from 'common/const';

export const useStorage = () => {
  const getStorageItem = (key: EStorageKey) => {
    return localStorage.getItem(key);
  };

  const setStorageItem = (key: EStorageKey, value: string) => {
    localStorage.setItem(key, value);
  };

  const removeStorageItem = (key: EStorageKey) => {
    localStorage.removeItem(key);
  };

  return { getStorageItem, setStorageItem, removeStorageItem };
};
